import PropTypes from 'prop-types';

export const AccountPropTypes = PropTypes.shape({
  allowAdjustmentFlag: PropTypes.string,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
});

export const AccountsPropTypes = PropTypes.arrayOf(AccountPropTypes);
